
  function markHelpful(button) {
    // Add clicked state
    button.classList.add('clicked');

    // Optional: Update text to show it was marked helpful
    const helpfulText = button.querySelector('.helpful-text');
    if (helpfulText) {
      helpfulText.textContent = 'Pomocne ✓';
    }

    // Disable the button to prevent multiple clicks
    button.disabled = true;

    // Here you could add AJAX call to save the helpful vote
    // Example:
    // const reviewId = button.dataset.reviewId;
    // fetch('/mark-helpful', { method: 'POST', body: JSON.stringify({reviewId}) });
  }

  // Report button functionality disabled - button does nothing when clicked
  function reportReview(button) {
    // Function disabled - no action taken
    return false;
  }
